package com.devi3east.bashbuddy.auth.navigation

import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.auth.ui.SignUpScreenRoute
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen

fun NavGraphBuilder.signUpNavGraph(
    appState: AppState
) {
    composable(Screen.SignUpScreen.route) {
        SignUpScreenRoute(
            appState = appState
        )
    }
}